'use strict';

import React, { useState, useCallback } from 'react'

import _ from 'lodash'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import getFormStatus from '@/Form/Functions/getFormStatus'

import ModelPicker from '@/Form/V2/ModelPicker'
import getFormData from '@/Form/Functions/getFormData'
import FileInputV2 from '@/Form/toolkit/FileInputV2'

import Message from '@Pure/Message'
import Loader  from '@Pure/Loader'

import request from '@function/ajax/request'
import bemit   from '@function/bemit'

const status_messages = { };

export default PageWrapper(function SorewardsImportPage (props)
{
	const [upload_id, setUploadId] = useState(1);
	const [form_data, setFormData] = useState({ });
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState({ });
	const [already_imported, setAlreadyImported] = useState([]);
	const [success, setSuccess] = useState([]);
	const [errors, setErrors] = useState([]);

	const handleFileChange = useCallback(function (e, data)
	{
		let name = data.name;

	// Binaires
		const __files = (form_data['__files-' + name] || [])
		.filter(function (file)
		{
			return file.form_name !== data.name;
		});

		if (data && data.value instanceof Array && data.value[0])
		{
			__files.push(data.value[0]);
		}

	// Informations
		const files_infos = (form_data[name] || [])
		.filter(function (file)
		{
			return file.form_name !== data.name;
		});

		if (data && data.value instanceof Array && data.value[0])
		{
			let infos = _.cloneDeep(data.value[0]);

			delete infos.file;
			delete infos.pdf;
			delete infos.image;

			files_infos.push(infos);
		}

		setFormData(
		{
			...form_data,

			['__files-' + name]: __files,
			[name]: files_infos,

			'__attachments': files_infos || []
		});
	},
	[form_data]);

	const handleCSEChange = useCallback(function ({ value, name, e })
	{
		setFormData(function (form_data)
		{
			return { ...form_data, EC_id: value };
		});
	},
	[]);

	const validate = useCallback(function (e)
	{
		setLoading(true);

		const data = getFormData({ state: form_data });

		setStatus({ status_messages: { }, error: undefined, errors: [] });

		(async function ()
		{
			try
			{
				var response = await request('/import/soreward-CSE-users')
				.config({ timeout: 30 * 60 * 1000, throw_response: true })
				.post(data);
			}
			catch (update)
			{
				const response = update.response || { };

				setLoading(false);
				setUploadId(id => id+1);

				setSuccess(response.success_lines || []);
				setErrors(response.errors || []);
				setAlreadyImported(response.already_imported_lines || []);

				return setStatus(
				{
					info: response.info,
					error: response.error,
					warning: response.warning
				});
			}

			setSuccess(response.success_lines || []);
			setErrors(response.errors || []);
			setAlreadyImported(response.already_imported_lines || []);

			setLoading(false);
			setUploadId(id => id+1);

			setStatus(
			{
				error: undefined, warning: undefined, info: undefined
			});

			setFormData({ '__files-import': [], import: [] });
		})();
	},
	[form_data]);

	let validate_btn_modifiers = ['extra'];

	if (!form_data.EC_id || status.info || !form_data.import?.length > 0)
	{
		validate_btn_modifiers.push('disabled');
	}

	const loader = loading === true ?
	(
		<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
	)
	: undefined;

	const errors_list = (errors || []).map(function (error)
	{
		return (
			<div className="c-form-message c-form-message--red u-no-margins"
				key={ error.id }>
				{ error.error }
				{ ' - ligne ' }
				{ error.line }
			</div>
		);
	});

	const form =
	(
		<div className="c-paper u-flex u-flex-wrap u-gap-30">
			<ModelPicker onChange={ handleCSEChange }
				name="EC_id"
				value={ form_data.EC_id }
				label="Recherche d'un CSE"
				model="enterprisecomitee"
				url="/autocomplete/ECs"
				bemit={ ['25%'] }
				resetable
			/>

			{
				form_data.EC_id ?
				(
					<FileInputV2 label="Fichier d'import"
						key={ String(upload_id) }
						name="import" multiple={ false }
						onChange={ handleFileChange }
						data={ form_data }
						status={ status_messages }
						button_txt="Ajouter ou modifier le fichier d'import"
						accept=".csv, .txt, .xlsx"
					/>
				)
				: undefined
			}

			<div className="u-full-width u-margin-top-20">

				<button type="button"
					disabled={ validate_btn_modifiers.includes('disabled')}
					className={ bemit('c-btn', validate_btn_modifiers) }
					onClick={ validate }>
					Importer ces utilisateurs
					{ loader }
				</button>

			</div>

			{ getFormStatus(status, { style: { width: '100%' } }) }

			{
				success?.length ?
				(
					<Message icon="checked" color="green"
						className="u-no-margins">
						Comptes importés&nbsp;:
						{ ' ' }
						{ success?.length }
						{ ' (' + success.join(', ') + ')' }
					</Message>
				)
				: undefined
			}

			{
				already_imported?.length ?
				(
					<Message icon="info" color="orange" className="u-no-margins">
						Déjà importés&nbsp;:
						{ ' ' }
						{ already_imported?.length }
					</Message>
				)
				: undefined
			}

			<div className="u-flex u-flex-column u-full-width u-gap-10">
				{ errors_list }
			</div>

		</div>
	);

	return (
		<Layout page_title="Import Sorewards" history={ props.history }>

			<div className="page-content">
				{ form }
			</div>

		</Layout>
	);
});